#import "../fragments/event-fragment-sparse.graphql"

query GetOpenThreads($id: ID!) {
    openThreads(id: $id) {
        ...EventFragmentSparse
    }
}
